import normalizeCodigoBanco from './normalizeCodigoBanco';

// Bancos homologados para segunda via de boleto pelo Portal (DTGD-1311).
// Código no padrão FEBRABAN (3 dígitos). Comparação ignora zeros à esquerda.
// `cor` é a cor institucional do banco, usada no badge da tabela/tag do
// modal de boleto — não tem relação com o tema (branding) do tenant.
const BANCOS_HOMOLOGADOS = [
  { codigo: '001', nome: 'Banco do Brasil', cor: '#0A3B7C' },
  { codigo: '033', nome: 'Santander', cor: '#EC0000' },
  { codigo: '104', nome: 'Caixa Econômica Federal', cor: '#0070AF' },
  { codigo: '237', nome: 'Bradesco', cor: '#CC092F' },
  { codigo: '341', nome: 'Itaú Unibanco', cor: '#EC7000' },
];

// Cor neutra para bancos fora da lista de homologados (código presente no
// título, mas sem emissão de segunda via pelo portal).
export const COR_BANCO_NAO_HOMOLOGADO = '#8C889A';

export function getBancoHomologado(codigoBanco) {
  const alvo = normalizeCodigoBanco(codigoBanco);
  if (!alvo) return undefined;
  return BANCOS_HOMOLOGADOS.find(
    banco => normalizeCodigoBanco(banco.codigo) === alvo,
  );
}

export function isBancoHomologado(codigoBanco) {
  return !!getBancoHomologado(codigoBanco);
}

export function getBancoCor(codigoBanco) {
  const banco = getBancoHomologado(codigoBanco);
  return banco ? banco.cor : COR_BANCO_NAO_HOMOLOGADO;
}

export default BANCOS_HOMOLOGADOS;
